import * as React from 'react';
import styled from "styled-components";
import {Bar} from 'react-chartjs-2';
import Filter from "../Filter";

export interface StatisticGendersProps {
  data: {
    men: number[],
    woman: number[]
  };
}

const Container = styled.div`
  display: grid;
  gap: 20px;
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: 
    minmax(375px, 380px)
    minmax(375px, 490px);
  gap: 18px;
`;

export default function StatisticGenders(props: StatisticGendersProps) {
  const [period, setPeriod] = React.useState<string | number>('today');

  /**
   * костыль чтобы высота графика доходила до значения 100
   */
  const helperData= {
    label: '',
    data: [100],
    backgroundColor: [
      'transparent',
    ],
    borderWidth: 0
  }

  const labels = [
    "до 18",
    "от 18 до 21",
    "от 21 до 24",
    "от 24 до 27",
    "от 27 до 30",
    "от 30 до 35",
    "от 35 до 45",
    "от 45 до 55",
    "от 55"
  ];

  const options = {
    scales: {
      y: [{
        ticks: {
          min: 0,
          max: 150,
          stepSize: 20
        }
      }]
    }
  }

  return (
    <Container>
      <Filter
        defaultValue={period}
        onChange={(value) => setPeriod(value)}
        items={[
          {
            label: 'Сегодня',
            value: 'today',
          },
          {
            label: 'Последний месяц',
            value: 'lastMonth',
          },
          {
            label: '3 месяца',
            value: 'threeMonth',
          },
          {
            label: '6 месяцев',
            value: 'sixMonth',
          },
          {
            label: 'Год',
            value: 'year',
          },
        ]}
      />
      <Row>
        <Bar
          data={{
            labels: labels,
            datasets: [
              {
                label: 'Мужчины',
                data: props.data.men,
                backgroundColor: [
                  '#93FFD1',
                ],
                borderWidth: 0
              },
              {
                label: 'Женщины',
                data: props.data.woman,
                backgroundColor: [
                  '#64ACD5',
                ],
                borderWidth: 0
              },
              helperData,
            ],
          }}
          options={options}
        />
      </Row>
    </Container>
  )
}